import React from 'react';
import { NotificationButton, CreateButton, ProfileButton } from 'ui';
import { Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const NavBar: React.FC = () => {
    const auth = useAuth();
    return (
        <Stack direction="row" justifyContent="space-evenly" width={'100%'}>
            <Stack
                justifyContent="flex-start"
                width="100%"
                alignItems="flex-start"
            >
                <Link
                    to="/home"
                    style={{
                        color: 'inherit',
                        textDecoration: 'none',
                        fontSize: 'x-large',
                    }}
                >
                    Bluechip Studio
                </Link>
            </Stack>
            <Stack
                width="100%"
                justifyContent="flex-end"
                direction="row"
                alignItems="center"
            >
                {!auth.isAuthenticated && (
                    <Button
                        variant="outlined"
                        color="inherit"
                        data-cy="nav-bar-sign-in-button"
                        onClick={() => auth.signinRedirect()}
                    >
                        Sign In
                    </Button>
                )}
                {auth.isAuthenticated && (
                    <>
                        <CreateButton />
                        <NotificationButton />
                        <ProfileButton />
                    </>
                )}
            </Stack>
        </Stack>
    );
};

export default NavBar;
